import { Badge, Button, Dropdown, Input } from 'antd';
import './ReportsFilters.less';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { ReactComponent as SearchOutlined } from '../../../res/svg/search.svg';
import { ReactComponent as ExpedienteSearch } from '../../../res/svg/expediente-search.svg';
import { ReactComponent as FilterSvg } from '../../../res/svg/filter.svg';
import { debounce } from '../../../utils/functions';
import { setReportsFilter, setShowFiltrosReports } from '../../../store/slice/reportsSlice';
import { useEffect, useMemo } from 'react';
import ReportsFilterDropdown from '../ReportsFilterDropdown/ReportsFilterDropdown';
import { getUserProfile } from '../../../store/slice/userSlice';

function ReportsFilters() {
  const dispatch = useAppDispatch();
  const filtros = useAppSelector(state => state.reports.filtros);
  const showFiltros = useAppSelector(state => state.reports.showFiltros);

  const onSearch = debounce((search: string) => {
    dispatch(setReportsFilter({ search}));
  }, 250, false);
  const onExpediente = debounce((expediente: string) => {
    dispatch(setReportsFilter({ expediente }));
  }, 250, false);

  useEffect(() => {
    dispatch(getUserProfile());
  }, []);

  const filterCount = useMemo(() =>
    (filtros.categorias.length > 0 as any) +
    (filtros.tipoTarea.length > 0 as any) +
    (filtros.fechaDesde !== undefined as any), [filtros]);

  return (
    <div className='ml-reports-filters__layout'>
      <Input
        className='ml-reports-filters-search-input'
        placeholder='Buscar'
        prefix={<SearchOutlined />}
        size='large'
        onChange={(e) => {
          onSearch(e.target.value);
        }}
      />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label htmlFor={'expediente'} className={'ml-reports-filter__input-label'}>
          N° de Expediente:
        </label>
        <Input
          name={'expediente'}
          className='ml-reports-filters-search-input'
          placeholder='Buscar'
          prefix={<ExpedienteSearch />}
          size='large'
          onChange={(e) => {
            onExpediente(e.target.value);
          }}
        />
      </div>
      <div className='at-filter-button__container'>
        <Badge count={filterCount} style={{ position: 'absolute', right: 5, top: 5 }}>
          <Dropdown
            placement={'bottom'}
            arrow={true}
            overlay={<ReportsFilterDropdown closeMenu={() => dispatch(setShowFiltrosReports(false))} />}
            onVisibleChange={(v) => dispatch(setShowFiltrosReports(v))}
            visible={showFiltros}
            trigger={['click']}
          >
            <Button
              onClick={(e) => e.stopPropagation()}
              className='ml-reports-filter__button-circle'
              size='large'
              shape='circle'
              type={showFiltros ? 'primary' : 'ghost'}
              color={'daybreak-blue.600'}
              icon={<FilterSvg style={{ marginBottom: -2, color: showFiltros ? 'white' : '#006854' }} />}
            />
          </Dropdown>
        </Badge>
      </div>
    </div>
  );
}

export default ReportsFilters;
